import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import ConfirmationModalTemplate from "@Shared/@HandlebarsTemplates/modals/_confirmation-modal.hbs";

/**
 * All classes are on this file because is a PITA to order them in the build process
 */
export class BaseModal {
  /**
   *
   * @param {Object} data Data for modal template
   * @param {String} template Handlebars partial name
   * @param {String} container Modal Container
   */
  constructor(data, templateFn, container = "body") {
    this.modalNode = null;
    this.modalAcceptButton = null;
    this._template = "";
    this._modalHTML = templateFn(data);
    this._container = container;
  }

  /**
   * Clears modal from DOM
   */
  removeModal() {
    this.modalNode.one("hidden.bs.modal", () => {
      this.beforeModalRemove();
      $(".modal-backdrop").remove();
      this.modalNode.remove();
    });
    this.modalNode.modal("hide");
  }

  /**
   * Appends modal to DOM
   */
  append() {
    this.modalNode = $(this._modalHTML);
    $(this._container).append(this.modalNode);
    this.findNodes();
  }

  /**
   * Finds modal nodes
   */
  findNodes() {
    var _context;
    const modalAcceptButton = _findInstanceProperty(_context = this.modalNode).call(_context, ".modal-accept");
    if (modalAcceptButton.length === 0) {
      const errorMessage = `No accept button found for template ${this.template}. Modal MUST include ".modal-accept" class in its accept button.`;
      //eslint-disable-next-line no-console
      console.error(errorMessage);
    }
    this.modalAcceptButton = modalAcceptButton;
  }

  /**
   * Callback based modal prompt, fires modal and executes callback
   * when accepted
   */
  load(loadOptions = {
    removeOnHide: true
  }) {
    this.beforeAppend();
    this.append();
    this.modalNode.modal();
    this.afterAppend(this.modalNode, this.modalAcceptButton);
    if (this.modalAcceptButton) this.modalAcceptButton.click(async () => {
      await this.onLoadAccept(this.modalNode, this.modalAcceptButton);
      this.removeModal();
    });
    if (loadOptions.removeOnHide) this.removeModal();
    this.modalNode.on("hidden.bs.modal", () => {
      this.onPromptClose(() => {});
    });
  }

  /**
   * Executed when accept button is clicked on callback based modal
   */
  async onLoadAccept() {
    //Left for overriding
  }

  /**
   * Executed after modal is appended to the container
   */
  //eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  afterAppend(modalNode) {
    //Left for overriding
  }

  /**
   * Executed before modal is appended to the container
   */
  beforeAppend() {
    //Left for overriding
  }

  /**
   * Executed when the accept button is clicked, but before removing the
   * modal
   */
  beforePromptAccept() {
    //Left for overriding
  }

  /**
   * Executed before the modal is closed
   */
  beforePromptClose() {
    //Left for overriding
  }

  /**
   * Executed after the modal is removed
   */
  beforeModalRemove() {
    //Left for overriding
  }

  /**
   * Promise based modal prompt, loads Modal then resolves promise to true
   * if user click confirmation, false otherwise
   */
  prompt() {
    return new _Promise((resolve, reject) => {
      this.beforeAppend();
      this.append();
      this.afterAppend(this.modalNode);
      const modal = this.modalNode;
      if (this.modalAcceptButton) {
        const modalAcceptButton = this.modalAcceptButton;
        modal.modal();
        modalAcceptButton.click(() => {
          this.beforePromptAccept(this.modalNode, this.modalAcceptButton);
          this.removeModal();
          this.onPromptAccept(resolve, reject);
        });
      }
      modal.on("hidden.bs.modal", () => {
        this.beforePromptClose(this.modalNode, this.modalAcceptButton);
        this.removeModal();
        this.onPromptClose(resolve, reject);
      });
    });
  }

  /**
   * Default behaviour, left for overriding
   */
  //eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  onPromptAccept(resolve, reject) {
    resolve(true);
  }

  /**
   * Default behaviour, left for overriding
   */
  //eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  onPromptClose(resolve, reject) {
    resolve(false);
  }
}
export class ConfirmationModal extends BaseModal {
  /**
   * @param cb Callback when accepted
   * @param data The data used for the confirmation modal.
   * @param closeCb
   * @param data.title Title of the modal
   * @param data.message Message of the modal
   * @param data.list List of consecuences if any
   * @param data.confirmButtonText Message of the modal
   * @param data.dismissButtonText Message of the modal
   * @param data.noDismiss Message of the modal
   * @param data.container Message of the modal
   */
  constructor(data, cb = () => {}, closeCb = () => {}) {
    super(data, ConfirmationModalTemplate, data.container || "body");
    this.cb = cb;
    this.closeCb = closeCb;
  }

  /**
   * See BaseModal.onLoadAccept
   */
  async onLoadAccept() {
    await this.cb();
  }
  async onPromptClose() {
    await this.closeCb();
  }
}
export class GenericModal extends BaseModal {
  /**
   *
   * @param {Object} data Data for modal template
   * @param {String} template Handlebars partial name
   * @param {String} container Modal Container
   */
  constructor(data, template, container) {
    super(data, template, container);
  }

  //removes the confirmation of a confirm button
  findNodes() {}
}

//eslint-disable-next-line no-unused-vars
export class VueModalBootstrapper {
  /**
   * Bootstraps and sets up a modal with a vuejs content inside
   * @param {Object} Vue An unmounted vm instance with all the needed props set
   * @param {String} template Handlebars partial for the base modal skeleton of the app
   * @param {String} container Container for the modal
   */
  constructor(Vue, templateFn, mountingPoint, container = "#body") {
    this.modalNode = null;
    this._vm = Vue;
    this._template = "";
    this._modalHTML = templateFn();
    this._container = container;
    this._mountingPoint = mountingPoint;
  }
  load(loadOptions = {
    mountOnShow: false
  }) {
    this.modalNode = $(this._modalHTML);
    $(this._container).append(this.modalNode);
    if (loadOptions.mountOnShow) {
      this.modalNode.one("shown.bs.modal", () => {
        this._vm.$mount(this._mountingPoint);
      });
      this.modalNode.modal();
    } else {
      {
        this.modalNode.modal();
        this._vm.$mount(this._mountingPoint);
      }
    }
    this.modalNode.on("hidden.bs.modal", () => {
      this.modalNode.modal("hide");
      this.modalNode.remove();
      $(".modal-backdrop").remove();
      this._vm.$destroy();
    });
  }
}